export default __webpack_public_path__ + "static/media/CPASAGE_Client home page icons-03.5cefdb38.svg";